import $            from "jquery";
import initDebounce from "../utilities/debounce";
import Alpine       from "alpinejs";

/**
 * Number of milliseconds to debounce the search.
 * 
 * @var {Number}
 */
const SEARCH_DEBOUNCE_MS = 500;

var postTypes = [];

/**
 * Startup
 */
export default function Search() {
    initDebounce( $ );
    $( initSearch );
}

/**
 * Post DOM loaded, initialise handlers.
 */
function initSearch() {
    $( "#full-search" ).on( { 
        submit: keyUpSearch,
        keyup:  $.debounce( SEARCH_DEBOUNCE_MS, keyUpSearch )
    } );

    // Bind window events from Alpine.
    $( window ).on( {
        "search-toggled": $.debounce( 150, function () { 
            // Change the state of the alpine.
            Alpine.$data( $( "#search-wrap" ).get( 0 ) ).search_showing = ! Alpine.$data( $( "#search-wrap" ).get( 0 ) ).search_showing;
            
            // Toggle classes.
            $( "html, body" ).toggleClass( "overflow-y-hidden h-full" );
        } ),
        "post-types-updated": $.debounce( 150, function () { 
            $( "#full-search" ).trigger( "keyup" );
        } )
    } );

    // When one of the preset search terms is clicked
    $( ".set-search-term" ).on( {
        "click": function ( event ) {
            // Set the search bar content
            $( "#full-search" ).val( event.target.dataset[ "searchTerm" ] ); 

            // Run the ajax search.
            $( "#full-search" ).trigger( "keyup" );
        }
    } );

    postTypes = jQuery( "#search-wrap" ).data( "default-post-types" );

    $( ".pt-checkbox" ).on( "change", function () { 
        if ( this.checked && ( ! postTypes.includes( this.value ) ) ) {
            postTypes.push( this.value );
        }

        if ( ( ! this.checked ) && ( postTypes.includes( this.value ) ) ) {
            var newPostTypes = [];
            var val = this.value;

            postTypes.forEach( v => { 
                if ( v !== val ) {
                    newPostTypes.push( v );
                }
            } );

            postTypes = newPostTypes;
        }

        // Simulate searching.
        $( "#full-search" ).trigger( "keyup" );
    } );
}

/**
 * Called on `keyup` event on the search box.
 */
function keyUpSearch() {
    getSearchResults( this.value.trim(), selectedPostTypes() ).then( results => { 
        $( "#search-results" ).html( results.html );

        // Bind the buttons.
        $( ".show-more-btn" ).on( "click", onClickShowMore );
    } ).catch( clearResults );
}

/**
 * Clears the results container.
 */
function clearResults( error = null ) { 
    $( "#search-results" ).html( "" ); 

    if ( error ) console.log( error );
}

/**
 * List of post types the user has selected.
 * 
 * @return {String[]}
 */
function selectedPostTypes() { 
    return postTypes;
}

/**
 * Called on click to any of the load more buttons.
 * 
 * @param {MouseEvent} event 
 */
function onClickShowMore( event ) {
    const target        = event.target;
    const postType      = target.dataset[ "postType" ];
    const currentPage   = $( target ).data( "page" ) ?? 2;

    // Ensure there's a valid post type.
    if ( ! postType ) {
        return;
    }

    // Increment the page counter.
    $( target ).data( "page", currentPage + 1 );

    // Get the results.
    getMoreSearchResults( $( "#full-search" ).val(), postType, currentPage ).then( results => { 
        // Append HTML if it's available.
        if ( results.html ) {
            $( `#results-${ postType }` ).append( results.html );
        }

        // Are we at the end of the posts to display.
        if ( results.done ) {
            $( target ).addClass( "hidden" );
        }
    } );
} 

/**
 * Get search results from the server.
 * 
 * @param {String} query 
 * @param {String[]} post_types List of post types to search on.
 */
async function getSearchResults( query, post_types = [] ) { 
    $.debounce( SEARCH_DEBOUNCE_MS * 3, mp_trackSearchEvent( query ) );

    // Fire the request and wait for it.
    return await $.ajax( {
        url:    `${window.location.origin}/wp-admin/admin-ajax.php`,
        method: "POST",
        data: { 
            action: "ifg_search",
            query: query,
            post_types: post_types
        }
    } );
}

/**
 * Gets more results for a single post type.
 * 
 * @param {String} query        The search term.
 * @param {String} post_type    The singular post type we're loading more of.
 * @param {Number} pageId       The page ID to grab.
 */
async function getMoreSearchResults( query, post_type, pageId ) { 
    return await $.ajax( {
        url: `${window.location.origin}/wp-admin/admin-ajax.php`,
        method: "POST",
        data: { 
            action:         "ifg_search",
            query:          query,
            post_types:     [ post_type ],
            paged:          pageId
        }
    } );
}

/**
 * Tracks a search event in mixPanel. This has to be debounced further against the search results.
 * 
 * @param {String} term
 */
async function mp_trackSearchEvent( term ) { 
    var mixpanel = window[ 'mixpanel' ];

    if ( ! mixpanel ) {
        mixpanel = {
            track: function ( ...argz ) {
                console.log( "Intercepted mixpanel track: ", argz );
            }
        }
    }

    mixpanel.track( "ifg:website_searchClicked", { term: term } );
}